import { classNames } from '@commenda/utils';
import React from 'react';

interface SummaryCardProps {
  label: string;
  count: number;
  isActive: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
}

export const SummaryCard = ({
  label,
  count,
  isActive,
  onClick,
  icon,
}: SummaryCardProps) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      'flex flex-1 flex-col gap-2 rounded-xl border bg-bg-primary p-4 text-left transition-colors cursor-pointer outline-none',
      isActive
        ? 'border-fg-brand ring-4 ring-[var(--color-bg-brand-hover)]'
        : 'border-border-primary hover:border-border-primary-hover'
    )}
  >
    <div className="flex items-center gap-2">
      {icon}
      <span className="txt-small-regular text-text-secondary">{label}</span>
    </div>
    <span className="txt-display-sm-semibold text-text-primary">{count}</span>
  </button>
);
